import { useApolloClient } from '@apollo/client';

import { ActivitiesContentType, LESSON_ACTIVITIES } from 'global/constants';
import type { GetDraftLessonActivitiesQuery } from '../../lesson-builder.graphql.generated';
import type { GetDraftAssessmentActivitiesQuery } from '../../assessment/assessment-builder.graphql.generated';
import { GET_DRAFT_ASSESSMENT_ACTIVITIES } from 'approot/activity-builder/assessment/assessment-builder.graphql';
import { GET_DRAFT_LESSON_ACTIVITIES } from 'approot/activity-builder/lesson-builder.graphql';
import { useGetInteractiveLessonParams } from 'approot/activity-builder/activity-builder.hooks';

export const useGetDraftActivitiesFromCache = ({
  contentId,
  contentType,
}: {
  contentId: number;
  contentType: ActivitiesContentType;
}) => {
  const { userClassId } = useGetInteractiveLessonParams();
  const client = useApolloClient();
  const isLesson = contentType === LESSON_ACTIVITIES;

  const data = client.readQuery<
    GetDraftLessonActivitiesQuery | GetDraftAssessmentActivitiesQuery
  >({
    query: isLesson
      ? GET_DRAFT_LESSON_ACTIVITIES
      : GET_DRAFT_ASSESSMENT_ACTIVITIES,
    variables: {
      input: {
        contentId,
        classId: userClassId,
      },
    },
  });

  return isLesson
    ? (data as GetDraftLessonActivitiesQuery)?.getDraftLessonActivities
    : (data as GetDraftAssessmentActivitiesQuery)?.getDraftAssessmentActivities;
};
